import Component from './MonitoredDocumentVersionsBrowser.component.jsx';
import { connect } from 'react-redux';
import { fetchMonitoredDocumentVersionsAction } from '../../state/actions/MonitoredDocumentActions';
import fromState from '../../state/selectors';

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    return {
        fetching: fromState.MonitoredDocumentVersions.isFetching(state),
        fetched: fromState.MonitoredDocumentVersions.isFetched(state),
        failed: fromState.MonitoredDocumentVersions.hasFailed(state),
        monitoredDocumentVersions:
            fromState.MonitoredDocumentVersions.getMonitoredDocumentVersions(state),
        paging: fromState.MonitoredDocumentVersions.getPaging(state),
    };
};

const mapDispatchToProps = (dispatch, { documentId, pageSize }) => {
    return {
        fetchMonitoredDocumentVersions: ({ pageNumber = 1, pageSize: defaultPageSize = 5 } = {}) =>
            dispatch(
                fetchMonitoredDocumentVersionsAction(
                    documentId,
                    pageNumber,
                    pageSize || defaultPageSize
                )
            ),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { pageSize } = ownProps;
    const {
        paging: { pageSize: defaultPageSize = 5 },
    } = stateProps;
    return {
        ...ownProps,
        ...stateProps,
        paging: {
            ...stateProps.paging,
            pageSize: pageSize || defaultPageSize,
        },
        onInitialLoad: dispatchProps.fetchMonitoredDocumentVersions,
        onPageClick: dispatchProps.fetchMonitoredDocumentVersions,
    };
};

// EXPORT CONTAINER
export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(
    Component
);
